export default __webpack_public_path__ + "static/media/style-angelusPavilion.5d8910b9.jpg";